import React from "react";

const IconCrown = ({ color = "red", ...props }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 2200 2200"
      {...props}
      fill={color}
    >
      <g id="background">
        <rect style={{ fill: "#fff" }} width="18" height="18" />
      </g>
      <g id="Objects">
        <g>
          <g>
            <path
              d="M1993.49,1692.301c-95.003,22.664-192.717,31.953-289.787,29.382c-72.61-2.064-145.303-10.5-216.078-26.633
				c-15.717-3.238-37.235-9.127-52.71-13.193c-13.347-3.747-26.59-7.856-39.761-12.227c33.431-13.496,66.361-28.232,98.615-44.273
				c1.842-0.796,3.234-2.458,3.929-4.445c8.934-24.025,27.531-72.066,37.086-95.866c82.657-205.909,184.247-405.359,301.998-593.377
				c-0.005-0.005,27.473-43.222,27.462-43.221c3.313-4.65,4.913-10.602,3.951-16.687c-1.948-12.324-13.518-20.734-25.842-18.787
				c-222.317,35.674-438.801,159.753-582.477,333.048c-0.159,0.196-0.32,0.397-0.479,0.593
				c-31.976-192.257-74.615-382.76-127.703-570.333c-1.327-4.962-4.491-9.494-9.208-12.403c-10.068-6.268-23.359-2.713-29.155,7.559
				c-59.583,96.808-115.175,196.072-167.477,297.008c-45.495,87.768-89.014,178.35-128.09,269.629
				c-50.227-64.341-113.241-118.628-183.053-160.763c-81.95-49.204-174.502-82.162-269.925-90.346
				c-16.073-2.635-27.344,14.97-19.487,28.429c7.366,12.789,15.206,25.22,22.939,37.643c5.724,9.88,12.725,21.464,18.553,31.14
				c7.773,13.428,15.428,26.91,23.147,40.362c5.909,10.777,12.382,22.854,18.654,33.967c6.224,12.13,14.019,26.667,20.351,38.927
				c5.686,11.473,12.686,25.349,18.503,36.992c54.817,111.499,98.456,229.841,133.093,349.223
				c3.81,13.555,7.582,27.147,11.644,40.709c5.329,16.243,28.932,11.334,27.399-5.625c-6.103-56.75-17.06-112.9-31.208-168.199
				c-27.199-103.678-66.103-205.169-118.635-298.809c-5.93-10.675-15.569-27.121-21.981-37.088c0,0-11.506-18.234-11.506-18.234
				l-1.444-2.274c0,0-1.522-2.229-1.522-2.229c-11.768-17.349-23.927-34.533-36.799-51.131
				c66.016,20.66,129.527,49.132,188.255,85.639c75.625,46.723,142.692,106.533,199.257,175.065
				c2.655,3.435,5.938,6.275,10.169,8.033c12.199,5.153,26.268-0.566,31.412-12.769c16.544-35.545,37.043-79.126,53.764-114.87
				c70.634-150.519,145.891-298.976,225.787-444.81c51.037,184.611,91.923,372.05,122.407,561.185
				c0.645,4.02,2.527,7.881,5.645,10.962c7.799,7.708,20.37,7.634,28.077-0.164c21.43-19.414,43.846-39.408,65.974-58.172
				c137.373-117.684,295.234-210.002,465.009-272.016c-7.704,13.211-14.898,25.677-19.821,34.439
				c-109.998,194.938-202.102,401.313-273.365,613.473c0,0-13.302,40.679-15.054,46.038c-37.093,17.828-75.078,33.908-113.7,48.269
				c-94.508-33.667-186.164-77.822-285.942-95.655c-52.365-9.353-105.718-13.744-158.844-14.372
				c-52.972-0.457-106.922,2.725-159.171,11.699c-18.619,3.128-37.558,7.129-55.768,12.139
				c-26.597,7.391-53.363,17.415-75.283,34.817c-31.273,24.587-45.665,68.688-14.187,99.667
				c24.98,24.191,64.692,31.489,97.381,38.78c48.686,9.559,98.867,14.719,148.431,16.713c83.446,3.273,167.625-0.693,250.057-14.427
				c63.967-11.06,126.92-27.645,188.535-47.937c13.613-4.502,27.164-9.21,40.652-14.101c14.77,5.054,29.585,9.881,44.38,14.31
				c10.246,2.862,26.087,7.266,36.062,9.998c185.325,46.455,386.362,44.216,569.577-10.46c2.58-0.789,4.15-3.464,3.515-6.124
				C1999.035,1693.349,1996.257,1691.641,1993.49,1692.301z M1282.443,1690.503c-56.788,17.038-114.71,30.687-173.34,39.522
				c-97.529,13.538-197.201,15.063-295.02,3.497c-35.526-4.193-71.793-10.737-106.375-19.961
				c-20.267-5.36-54.214-14.932-65.878-32.74c-7.021-11.122-1.148-24.505,7.1-33.743c4.76-5.476,10.925-9.977,17.072-13.793
				c16.745-10.04,35.578-16.13,54.541-21.01c11.122-2.884,23.303-5.378,34.658-7.446c4.314-0.917,13.415-2.413,17.583-3.006
				c5.888-0.915,11.752-1.916,17.705-2.573c17.007-2.278,36.487-4.289,53.625-5.409c44.733-3.305,90.434-3.425,135.226-1.163
				c38.825,2.208,77.759,6.582,115.909,13.939c59.158,11.866,115.337,32.152,172.659,53.455
				c16.927,6.295,34.075,12.672,51.338,18.869C1307.025,1682.958,1294.757,1686.818,1282.443,1690.503z"
            />
          </g>
          <g>
            <path
              d="M257.63,832.57c-0.131-0.074-0.263-0.148-0.394-0.221c-26.925-14.917-61.444-1.478-70.75,27.863
				c-0.514,1.621-0.956,3.268-1.32,4.937c-5.424,24.847,8.541,52.827,32.069,62.456c23.528,9.629,53.8-1.22,64.945-24.072
				C294.266,878.752,281.653,846.123,257.63,832.57z"
            />
          </g>
          <g>
            <path
              d="M1113.477,547.807c23.528,9.629,53.8-1.22,64.946-24.072c12.085-24.781-0.528-57.41-24.55-70.963
				c-0.131-0.074-0.263-0.148-0.394-0.22c-26.925-14.917-61.444-1.478-70.75,27.863c-0.514,1.621-0.956,3.268-1.32,4.937
				C1075.984,510.199,1089.949,538.178,1113.477,547.807z"
            />
          </g>
          <g>
            <path
              d="M1986.798,785.277c-0.131-0.074-0.263-0.148-0.394-0.221c-26.925-14.917-61.444-1.478-70.75,27.863
				c-0.514,1.621-0.956,3.268-1.32,4.937c-5.424,24.847,8.541,52.827,32.069,62.456c23.528,9.629,53.8-1.22,64.945-24.072
				C2023.433,831.459,2010.82,798.83,1986.798,785.277z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconCrown;
